import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
import{erpplatserver} from '@/utils/baseUrl';

//获取退库申请列表
export async function getCjReturnList(params) {
    return post(erpserver+'/workShop/getCjReturnList', params, true)
}

//获取退库申请品种列表
export async function getCjReturnPzList(params) {
    return post(erpserver+'/workShop/getCjReturnPzList', params, true)
}

//保存/编辑退库申请
export async function saveCjReturn(params) {
    return post(erpserver+'/workShop/saveCjReturn', params, true)
}

//查看退库申请
export async function getCjReturnDetails(params) {
    return post(erpserver+'/workShop/getCjReturnDetails', params, true)
}